import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface termDataListDetailsProps {
  id: string;
  academicYearId: number;
  termCode: string;
  displayName: string;
  startDate: Date | null;
  endDate: Date | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  rewardToggleOn: boolean;
  currentTerm: boolean;
}

export interface eventPointsListProps {
  id: number;
  name: string;
  points: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface OCSuccessRewards {
  id: number;
  academicYearId: string; // UUID
  ocSuccessReward: number;
  ocSuccessRewardBonus: number;
  rewardToggleOn: boolean;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
}

export interface academicYearData {
  id: string; // UUID
  years: string; // e.g. "25-26"
  displayYear: string | null;
  isActive: boolean;
  activatedAt: string | null; // ISO date string
  ocAllIn: boolean;
  plc: boolean;
  dts: boolean;
  thirtyForThirty: boolean;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  termCount: string; // Consider number if it represents numeric value
}

interface termDataState {
  termDataList_details: termDataListDetailsProps[];
  termDataOcSuccessReward: OCSuccessRewards | null;
  eventPointsList: eventPointsListProps[];
  academicYearData: academicYearData[];
}

//let termCodes = JSON.parse(localStorage.getItem("oc_all_in_termCodes") || "[]");

let initialState: termDataState = {
  termDataList_details: [],
  termDataOcSuccessReward: null,
  eventPointsList: [],
  academicYearData: [],
};

const TermDataSliceReducer = createSlice({
  name: "TermData",
  initialState,
  reducers: {
    setTermDataListDetails(
      state,
      action: PayloadAction<termDataListDetailsProps[]>,
    ) {
      state.termDataList_details = action.payload;
    },
    setTermDataOcSuccessRewards(
      state,
      action: PayloadAction<OCSuccessRewards | null>,
    ) {
      state.termDataOcSuccessReward = action.payload;
    },
    setEventPointsListDetails(
      state,
      action: PayloadAction<eventPointsListProps[]>,
    ) {
      state.eventPointsList = action.payload;
    },
    setAcademicYearData(state, action: PayloadAction<academicYearData[]>) {
      state.academicYearData = [...action.payload];
    },
  },
});

export const {
  setTermDataListDetails,
  setTermDataOcSuccessRewards,
  setEventPointsListDetails,
  setAcademicYearData,
} = TermDataSliceReducer.actions;

export default TermDataSliceReducer.reducer;
